/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { forwardRef } from 'react';
import ArrowLeft from '@atlaskit/icon/core/migration/arrow-left';
import ArrowRight from '@atlaskit/icon/core/migration/arrow-right';
import { MediaFilmStripListItemSelector } from '.';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N20, N40, B400, B50 } from '@atlaskit/theme/colors';
var filmStripViewStyles = css({
  position: 'relative',
  padding: "var(--ds-space-025, 3px)".concat(" 0"),
  borderRadius: '3px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .arrow': {
    opacity: 1
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.ellipsed-text': {
    whiteSpace: 'initial'
  }
});
var filmStripListWrapperStyles = css({
  width: 'inherit',
  overflow: 'hidden',
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-025, 3px)")
});
var filmStripListStyles = css({
  margin: 0,
  padding: 0,
  transitionProperty: 'transform',
  transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
  whiteSpace: 'nowrap',
  display: 'inline-block'
});
var filmStripListItemStyles = css({
  listStyleType: 'none',
  margin: 0,
  padding: "0 ".concat("var(--ds-space-050, 4px)"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  ':first-of-type': {
    paddingLeft: 0
  },
  display: 'inline-block',
  verticalAlign: 'middle',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  fontSize: 0
});
var arrowWrapperStyles = css({
  position: 'absolute',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: "var(--ds-surface-overlay, ".concat(N20, ")"),
  borderRadius: '100%',
  display: 'flex',
  cursor: 'pointer',
  transition: 'opacity 0.3s',
  boxShadow: "var(--ds-shadow-overlay, 0 1px 6px 0 rgba(0, 0, 0, 0.6))",
  color: "var(--ds-icon, black)",
  width: '30px',
  height: '30px',
  justifyContent: 'center',
  opacity: 0,
  '&:hover': {
    color: "var(--ds-text-subtle, black)",
    backgroundColor: "var(--ds-surface-overlay-hovered, ".concat(N40, ")")
  },
  '&:active': {
    color: "var(--ds-text-selected, ".concat(B400, ")"),
    backgroundColor: "var(--ds-background-selected, ".concat(B50, ")")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    height: '30px',
    width: '20px'
  }
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var arrowLeftWrapperStyles = css(arrowWrapperStyles, {
  left: "var(--ds-space-100, 8px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    paddingRight: "var(--ds-space-025, 2px)"
  }
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var arrowRightWrapperStyles = css(arrowWrapperStyles, {
  right: "var(--ds-space-100, 8px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    paddingLeft: "var(--ds-space-025, 2px)"
  }
});
var shadowStyles = css({
  position: 'absolute',
  zIndex: 10,
  height: '100%',
  top: 0,
  width: '2px',
  backgroundColor: "var(--ds-border, rgba(0, 0, 0, 0.2))"
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var shadowLeftStyles = css(shadowStyles, {
  left: 0
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var shadowRightStyles = css(shadowStyles, {
  right: 0
});
var ShadowLeft = function ShadowLeft(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: shadowLeftStyles
  }, children);
};
export var ArrowLeftWrapper = function ArrowLeftWrapper(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    jsx("div", {
      css: arrowLeftWrapperStyles,
      className: "arrow",
      onClick: onClick
    }, children)
  );
};
export var ShadowRight = function ShadowRight(_ref3) {
  var children = _ref3.children;
  return jsx("div", {
    css: shadowRightStyles
  }, children);
};
export var ArrowRightWrapper = function ArrowRightWrapper(_ref4) {
  var children = _ref4.children,
    onClick = _ref4.onClick;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    jsx("div", {
      css: arrowRightWrapperStyles,
      className: "arrow",
      onClick: onClick
    }, children)
  );
};
export var LeftArrow = function LeftArrow(_ref5) {
  var onClick = _ref5.onClick;
  return jsx(ShadowLeft, null, jsx(ArrowLeftWrapper, {
    onClick: onClick
  }, jsx(ArrowLeft, {
    color: "currentColor",
    spacing: "spacious",
    label: "left"
  })));
};
export var RightArrow = function RightArrow(_ref6) {
  var onClick = _ref6.onClick;
  return jsx(ShadowRight, null, jsx(ArrowRightWrapper, {
    onClick: onClick
  }, jsx(ArrowRight, {
    color: "currentColor",
    spacing: "spacious",
    label: "right"
  })));
};
export var FilmStripViewWrapper = function FilmStripViewWrapper(_ref7) {
  var children = _ref7.children,
    dataTestId = _ref7['data-testid'];
  return jsx("div", {
    css: filmStripViewStyles,
    "data-testid": dataTestId
  }, children);
};
export var FilmStripListWrapper = /*#__PURE__*/forwardRef(function (_ref8, ref) {
  var children = _ref8.children,
    onWheel = _ref8.onWheel,
    onTouchStart = _ref8.onTouchStart,
    onTouchMove = _ref8.onTouchMove,
    onTouchEnd = _ref8.onTouchEnd,
    dataTestId = _ref8['data-testid'];
  return jsx("div", {
    css: filmStripListWrapperStyles,
    ref: ref,
    onWheel: onWheel,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    "data-testid": dataTestId
  }, children);
});
export var FilmStripList = /*#__PURE__*/React.forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
    style = _ref9.style;
  return jsx("ul", {
    css: filmStripListStyles,
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style
  }, children);
});
export var FilmStripListItem = function FilmStripListItem(_ref10) {
  var children = _ref10.children,
    index = _ref10.index;
  return jsx("li", {
    css: filmStripListItemStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: MediaFilmStripListItemSelector,
    "data-testid": "media-filmstrip-list-item",
    key: index
  }, children);
};